// Shopify Variant Quantity Limiter - Fixed Auto Refresh
(function() {
  'use strict';
  
  // CONFIGURATION
  const CONFIG = {
    variantId: 57045349499264,  // Your variant ID
    maxQuantity: 3,             // Maximum allowed quantity
    debug: false,
    countAllInstances: true,    // Count ALL instances regardless of properties
    autoRefresh: true,          // Automatically refresh page after fixing quantities
    refreshDelay: 1200          // Delay before refresh (ms)
  };
  
  // State tracking
  let isProcessing = false;
  let shouldRefresh = false;
  let refreshScheduled = false;
  let currentNotification = null;
  let isAdjustingQuantity = false;
  
  // Debug logging
  function log(...args) {
    if (CONFIG.debug) {
      console.log('[Variant Limiter]', ...args);
    }
  }
  
  // Main function to check and enforce limits
  async function enforceQuantityLimits() {
    if (isProcessing || isAdjustingQuantity) return;
    isProcessing = true;
    
    try {
      // Get current cart data
      const cart = await fetchCart();
      if (!cart || !cart.items || cart.items.length === 0) {
        isProcessing = false;
        return;
      }
      
      // Find ALL instances of our target variant
      const targetItems = cart.items.filter(item => 
        item.variant_id === CONFIG.variantId
      );
      
      log('Found target items:', targetItems);
      
      if (targetItems.length > 0) {
        if (CONFIG.countAllInstances) {
          // Count TOTAL quantity across all instances
          const totalQuantity = targetItems.reduce((sum, item) => sum + item.quantity, 0);
          
          if (totalQuantity > CONFIG.maxQuantity) {
            log(`Total quantity ${totalQuantity} exceeds limit of ${CONFIG.maxQuantity}`);
            
            // Show error message
            showNotification(`Maximum ${CONFIG.maxQuantity} of this item allowed per order. Adjusting quantities...`);
            
            // Update UI immediately
            updateUIQuantities(CONFIG.maxQuantity);
            
            // Then reduce quantities in cart
            const fixed = await reduceTotalQuantity(targetItems, totalQuantity);
            
            if (fixed && CONFIG.autoRefresh && window.location.pathname.includes('/cart')) {
              shouldRefresh = true;
              schedulePageRefresh();
            }
            
            return;
          }
        } else {
          // Limit each individual instance
          let needsFix = false;
          
          for (const item of targetItems) {
            if (item.quantity > CONFIG.maxQuantity) {
              needsFix = true;
              break;
            }
          }
          
          if (needsFix) {
            showNotification(`Maximum ${CONFIG.maxQuantity} of this item allowed per order. Adjusting quantities...`);
            
            // Update UI immediately
            updateUIQuantities(CONFIG.maxQuantity);
            
            for (const item of targetItems) {
              if (item.quantity > CONFIG.maxQuantity) {
                await updateCartQuantity(item.key, CONFIG.maxQuantity);
              }
            }
            
            if (CONFIG.autoRefresh && window.location.pathname.includes('/cart')) {
              shouldRefresh = true;
              schedulePageRefresh();
            }
          }
        }
      }
      
    } catch (error) {
      log('Error enforcing limits:', error);
      showNotification('Error checking cart quantities.');
    } finally {
      isProcessing = false;
    }
  }
  
  // Immediately update UI quantities
  function updateUIQuantities(maxQuantity) {
    if (isAdjustingQuantity) return;
    isAdjustingQuantity = true;
    
    try {
      // Find all quantity inputs that might be for our variant
      const quantityInputs = document.querySelectorAll('input[name="quantity"], input[type="number"].cart__qty-input, .cart__qty-input input, .quantity input, [data-quantity-input]');
      
      log('Found quantity inputs:', quantityInputs.length);
      
      // First, try to find our specific variant by looking for text content
      const cartItems = document.querySelectorAll('.cart-item, .cart__row, [data-cart-item], tr[data-cart-item]');
      
      cartItems.forEach((item, index) => {
        const itemText = item.textContent;
        // Look for keywords that might identify your product
        if (itemText.includes('Luma Harvest Oak') || itemText.includes('3mm Herringbone')) {
          log('Found target product in cart item', index);
          
          // Find quantity input within this item
          const quantityInput = item.querySelector('input[name="quantity"], input[type="number"].cart__qty-input, .cart__qty-input input, .quantity input, [data-quantity-input]');
          
          if (quantityInput) {
            const currentValue = parseInt(quantityInput.value);
            if (currentValue > maxQuantity) {
              log(`Adjusting quantity from ${currentValue} to ${maxQuantity}`);
              quantityInput.value = maxQuantity;
              
              // Trigger change event
              quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
              quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        }
      });
      
      // Also check all inputs and adjust any that are over the limit
      quantityInputs.forEach(input => {
        const value = parseInt(input.value);
        if (value > maxQuantity) {
          log('Adjusting general quantity input:', value, '→', maxQuantity);
          input.value = maxQuantity;
          
          // Trigger change event
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
      
    } catch (error) {
      log('Error updating UI quantities:', error);
    } finally {
      setTimeout(() => {
        isAdjustingQuantity = false;
      }, 100);
    }
  }
  
  // Reduce total quantity across multiple items
  async function reduceTotalQuantity(items, totalQuantity) {
    const excess = totalQuantity - CONFIG.maxQuantity;
    log(`Need to reduce by ${excess} items`);
    
    // Create array of update promises
    const updatePromises = [];
    let remainingToRemove = excess;
    
    // Remove from last items first
    for (let i = items.length - 1; i >= 0 && remainingToRemove > 0; i--) {
      const item = items[i];
      const removeFromThisItem = Math.min(remainingToRemove, item.quantity);
      
      if (removeFromThisItem > 0) {
        const newQuantity = item.quantity - removeFromThisItem;
        
        updatePromises.push(
          updateCartQuantity(item.key, newQuantity)
        );
        
        remainingToRemove -= removeFromThisItem;
      }
    }
    
    // Wait for all updates to complete
    try {
      await Promise.all(updatePromises);
      log('All quantity updates completed');
      return true;
    } catch (error) {
      log('Error updating quantities:', error);
      return false;
    }
  }
  
  // Schedule page refresh (ensures it only happens once)
  function schedulePageRefresh() {
    if (refreshScheduled || !shouldRefresh) return;
    
    refreshScheduled = true;
    log(`Scheduling page refresh in ${CONFIG.refreshDelay}ms`);
    
    setTimeout(() => {
      if (window.location.pathname.includes('/cart')) {
        log('Refreshing cart page now...');
        window.location.reload();
      }
    }, CONFIG.refreshDelay);
  }
  
  // Fetch cart data
  async function fetchCart() {
    try {
      const response = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        },
        cache: 'no-cache'
      });
      
      if (!response.ok) throw new Error('Failed to fetch cart');
      return await response.json();
    } catch (error) {
      log('Error fetching cart:', error);
      return null;
    }
  }
  
  // Update item quantity in cart
  async function updateCartQuantity(itemKey, quantity) {
    try {
      log(`Updating item ${itemKey} to quantity ${quantity}`);
      
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity
        })
      });
      
      if (!response.ok) throw new Error('Failed to update cart');
      
      return await response.json();
    } catch (error) {
      log('Error updating cart:', error);
      throw error;
    }
  }
  
  // Show notification to user
  function showNotification(message) {
    // Remove any existing notifications
    if (currentNotification) {
      currentNotification.remove();
      currentNotification = null;
    }
    
    document.querySelectorAll('.variant-limit-notification').forEach(el => el.remove());
    
    // Create notification
    const notification = document.createElement('div');
    notification.className = 'variant-limit-notification';
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #d32f2f;
      color: white;
      padding: 15px 25px;
      border-radius: 8px;
      z-index: 10000;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 14px;
      font-weight: 500;
      box-shadow: 0 6px 20px rgba(0,0,0,0.2);
      animation: slideIn 0.4s ease;
      max-width: 350px;
      text-align: center;
      border-left: 5px solid #ff9800;
    `;
    
    notification.innerHTML = `
      <div style="display: flex; align-items: center; gap: 10px;">
        <svg style="width: 20px; height: 20px; flex-shrink: 0;" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
        </svg>
        <span>${message}</span>
      </div>
    `;
    
    document.body.appendChild(notification);
    currentNotification = notification;
    
    // Keep notification for 4 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => {
          if (notification.parentNode) {
            notification.remove();
            currentNotification = null;
          }
        }, 300);
      }
    }, 4000);
  }
  
  // Force quantity adjustment on input
  function forceQuantityAdjustment(event) {
    if (isAdjustingQuantity) return;
    
    const target = event.target;
    
    // Check if this is a quantity input
    const isQuantityInput = 
      target.name === 'quantity' || 
      target.type === 'number' && 
      (target.classList.contains('cart__qty-input') || 
       target.closest('.cart__qty-input') ||
       target.classList.contains('quantity') ||
       target.hasAttribute('data-quantity-input'));
    
    if (!isQuantityInput) return;
    
    const value = parseInt(target.value);
    if (isNaN(value)) return;
    
    // Check if this is for our variant
    const cartItem = target.closest('.cart-item, .cart__row, [data-cart-item], tr[data-cart-item]');
    let isTargetVariant = false;
    
    if (cartItem) {
      if (cartItem.dataset?.variantId == CONFIG.variantId || cartItem.dataset?.sampleItem === 'true') {
        isTargetVariant = true;
      }
      const itemText = cartItem.textContent;
      // Check for product identifiers
      if (itemText.includes('Luma Harvest Oak') || 
          itemText.includes('3mm Herringbone') ||
          itemText.includes('SampleProductValue')) {
        isTargetVariant = true;
      }
    }
    
    // Also check if we're on the cart page and there's only one item
    if (!isTargetVariant && document.querySelectorAll('.cart-item, .cart__row').length === 1) {
      isTargetVariant = true; // Assume it's our variant if only one item in cart
    }
    
    if (isTargetVariant && value > CONFIG.maxQuantity) {
      log(`Force adjusting quantity from ${value} to ${CONFIG.maxQuantity}`);
      
      // Show notification
      showNotification(`Maximum ${CONFIG.maxQuantity} of this item allowed per order.`);
      
      // Adjust the value immediately
      target.value = CONFIG.maxQuantity;
      
      // Trigger events
      target.dispatchEvent(new Event('change', { bubbles: true }));
      target.dispatchEvent(new Event('input', { bubbles: true }));
      
      // Update cart asynchronously
      setTimeout(enforceQuantityLimits, 100);
    }
  }
  
  // Add CSS animations
  function addStyles() {
    if (!document.querySelector('#variant-limiter-styles')) {
      const style = document.createElement('style');
      style.id = 'variant-limiter-styles';
      style.textContent = `
        @keyframes slideIn {
          from { transform: translateX(100%) translateY(-20px); opacity: 0; }
          to { transform: translateX(0) translateY(0); opacity: 1; }
        }
        @keyframes slideOut {
          from { transform: translateX(0) translateY(0); opacity: 1; }
          to { transform: translateX(100%) translateY(-20px); opacity: 0; }
        }
      `;
      document.head.appendChild(style);
    }
  }
  
  // Setup all event listeners
  function setupEventListeners() {
    // Force quantity adjustment on any input
    document.addEventListener('input', forceQuantityAdjustment);
    document.addEventListener('change', forceQuantityAdjustment);
    
    // Monitor quantity button clicks
    document.addEventListener('click', function(e) {
      const target = e.target;
      const button = target.closest('button');
      
      if (button && (
        button.classList.contains('cart__qty-button') ||
        button.textContent.includes('+') ||
        button.textContent.includes('-') ||
        button.querySelector('svg') ||
        button.hasAttribute('data-quantity-increase') ||
        button.hasAttribute('data-quantity-decrease')
      )) {
        log('Quantity button clicked');
        
        // Wait for Shopify to update the input, then check
        setTimeout(() => {
          // Find the quantity input
          const quantityInput = document.querySelector('input[name="quantity"], .cart__qty-input input, input[type="number"]');
          if (quantityInput) {
            forceQuantityAdjustment({ target: quantityInput });
          }
          
          // Also run async check
          setTimeout(enforceQuantityLimits, 200);
        }, 150);
      }
    });
    
    // Monitor for quantity changes
    document.addEventListener('change', function(e) {
      if (e.target.name === 'quantity' || e.target.type === 'number') {
        log('Quantity input changed (general)');
        setTimeout(enforceQuantityLimits, 100);
      }
    });
    
    // Intercept AJAX requests
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const fetchPromise = originalFetch.apply(this, args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
        if (url && typeof url === 'string' && url.includes('/cart/')) {
          fetchPromise.then(() => {
            setTimeout(enforceQuantityLimits, 150);
          }).catch(() => {});
        }
      } catch (e) {}
      return fetchPromise;
    };
    
    // Safety check interval
    setInterval(enforceQuantityLimits, 15000);
  }
  
  // Initialize
  function init() {
    log('Variant Quantity Limiter Initialized');
    log('Variant ID:', CONFIG.variantId);
    log('Max Quantity:', CONFIG.maxQuantity);
    
    addStyles();
    setupEventListeners();
    
    // Initial check
    setTimeout(enforceQuantityLimits, 1500);
    
    // Also force check on page load
    if (window.location.pathname.includes('/cart')) {
      setTimeout(() => {
        // Find and check all quantity inputs
        const quantityInputs = document.querySelectorAll('input[name="quantity"], input[type="number"]');
        quantityInputs.forEach(input => {
          forceQuantityAdjustment({ target: input });
        });
      }, 2000);
    }
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();